// extracted by mini-css-extract-plugin
export default {"variantsWrapper":"XLhQ7","variant":"yp6VJ"};